import React from "react";

export default function Ex1_Model() {
  return (
    <div>
      <h1>Ex1_Model</h1>
      <p>This is the Ex1_Model component.</p>
    </div>
  );
}
